var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3924 13.8725L11.1211 15.1017M19.5965 15.1017L18.3252 13.8725M12.8162 20.4285L11.9686 21.248M17.9014 20.4285L18.749 21.248M15.3588 16.331V17.97L16.2064 18.7895M15.3588 21.248C16.2579 21.248 17.1203 20.9026 17.756 20.2879C18.3918 19.6731 18.749 18.8394 18.749 17.97C18.749 17.1006 18.3918 16.2668 17.756 15.6521C17.1203 15.0374 16.2579 14.692 15.3588 14.692C14.4597 14.692 13.5974 15.0374 12.9616 15.6521C12.3258 16.2668 11.9686 17.1006 11.9686 17.97C11.9686 18.8394 12.3258 19.6731 12.9616 20.2879C13.5974 20.9026 14.4597 21.248 15.3588 21.248Z",
    stroke: "#B1B1B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 9.87657V6.29902C17.7949 4.67446 17.7949 3.86219 17.4679 3.24169C17.1803 2.69588 16.7214 2.25213 16.1569 1.97403C15.5152 1.65787 14.6751 1.65787 12.9949 1.65787H6.59492C4.91476 1.65787 4.07469 1.65787 3.43295 1.97403C2.86846 2.25213 2.40952 2.69588 2.1219 3.24169C1.79492 3.86219 1.79492 4.67446 1.79492 6.29902V16.3548C1.79492 17.9794 1.79492 18.7917 2.1219 19.4122C2.40952 19.958 2.86846 20.4017 3.43295 20.6798C4.07469 20.996 4.91476 20.996 6.59492 20.996H9.79492M11.7949 10.36H5.79492M7.79492 14.2277H5.79492M13.7949 6.4924H5.79492",
    stroke: "#B1B1B1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAssessment);
export default __webpack_public_path__ + "static/media/menu_assessment.fa78b7d4ca0dff0c2d1cb094f0f69009.svg";
export { ForwardRef as ReactComponent };